module.exports = __webpack_public_path__ + "img/main-prize.3fe83b40.png";